export default __webpack_public_path__ + "static/media/a3.9974f16e.jpg";